import { getDeployEnvironment } from '@/lib/deployEnvironment';
import { v1, toResult } from '@/infrastructure/api/v1/client';
import { environmentTypeToLegacy } from '@/infrastructure/api/v1/mappers/environmentTypes';
import type { EnvironmentPreferences } from './useEnvironmentPreferences';

export async function readEnvironmentPreferences(): Promise<EnvironmentPreferences | null> {
  const { data, error } = await toResult(v1.GET('/api/v1/environment-types/{name}', {
    params: { path: { name: getDeployEnvironment() } },
  }));
  if (error) {
    if (error.status === 404) return null;
    throw error;
  }
  const prefs: unknown = environmentTypeToLegacy(data).environment_preferences;
  if (typeof prefs === 'string') return JSON.parse(prefs) as EnvironmentPreferences;
  if (prefs && typeof prefs === 'object') return prefs as EnvironmentPreferences;
  return null;
}

// A failed read allows sign-up, so a blip never turns a real person away
export async function isSignUpOpen(): Promise<boolean> {
  try {
    return (await readEnvironmentPreferences())?.sign_up_on === true;
  } catch {
    return true;
  }
}
